import { render, staticRenderFns } from "./venue.vue?vue&type=template&id=2a80129f"
import script from "./venue.vue?vue&type=script&lang=js"
export * from "./venue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports